
const state = {
  RouterList: null                         //路由列表
}

const getters = {
  RouterList(state) {
    return state.RouterList || JSON.parse(sessionStorage.getItem('RouterList'))
  },
}

const mutations = {
  SAVE_RouterList(state, value) {
    state.RouterList = value;
    sessionStorage.setItem('RouterList', JSON.stringify(value))
  },
  REMOVE_RouterList(state) {
    sessionStorage.removeItem('RouterList')
    state.RouterList = null;
  },
}

const actions = {
  saveRouterList(context, value) {
    context.commit('SAVE_RouterList', value)
  },

  removeRouterList(context) {
    context.commit('REMOVE_RouterList')
  },

  removeAll(context) {
    context.commit('REMOVE_RouterList')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/js/store/modules/permission.js